export const cardStyles = {
  border: ({ palette }) => `1px solid ${palette.border.default}`,
  borderRadius: '8px',
  backgroundColor: ({ palette }) => palette.background.paper,
  overflow: 'hidden',
};

export const getHeaderStyles = ({ isHighlighted }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px 16px',
  padding: '12px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
  backgroundColor: ({ palette }) =>
    isHighlighted ? palette.background.secondary : palette.background.paper,
});

export const headerMainStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '8px 12px',
};
